module.exports = __webpack_public_path__ + "static/media/spr_notice_information.cdb81d45.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/spr/documents/adhesion/spr_notice_information.pdf
// module id = 857
// module chunks = 40